"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SEARCH_SHADE = exports.MAX_VISIBLE_SHADES_COUNT = void 0;
const MAX_VISIBLE_SHADES_COUNT = exports.MAX_VISIBLE_SHADES_COUNT = 5;
const SEARCH_SHADE = exports.SEARCH_SHADE = 'search-shade';
